import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@shared/store/auth.store';

const checkUserLogin = (route: ActivatedRouteSnapshot, url: any): boolean => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (!!authStore.user()) {
    const userRole = authStore.user()!.role;

    if (route.data['role'] && route.data['role'].indexOf(userRole) === -1) {
      router.navigate(['/forbidden']);
      return false;
    }

    return true;
  }

  router.navigate(['/forbidden']);
  return false;
};

export const authGuard: CanActivateFn = (route, state): boolean =>
  checkUserLogin(route, state.url);
